import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import FilterView from './FilterView';
import SubcriptionsView from './SubcriptionsView';
import crmservices from '../../wsclient/';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { getAppCfg, getCurrency, getServiceChangeInfo, setServiceChangeInfo } from '../../utils/common';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import ProductsView from './ProductsView';
import ModalConfirm from '../../components/ModalConfirm';
import { convertEpochTime, formatDateToDDMMYYYY, formatDateToDDMMYYYYFrEpoch, formatPeriodDate } from '../../utils/util';
import { Currencies } from '../../../Currencies';
import { aynaottservices } from '../../wsclient/crmservices/aynaottservices';
import { paths } from '../../../portal.router.config';
import { domainName } from '../../../portal.config';

const styles = theme => ({

});

function Subcriptions(props) {
    const { t } = props;
    const [openFilter, setOpenFilter] = useState(false);
    const [filter_options, setFilterOptions] = useState(null);
    const [filterSelected, setFilterSelected] = useState(1);

    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [subcriptions, setSubcriptions] = useState(null);
    const [mainLoading, onMainLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    })
    //change service
    const [serviceDevices, setServiceDevices] = useState([]);
    const [serviceSelected, setServiceSelected] = useState(null);
    const [subscriptionSeleted, setSubscriptionSelected] = useState(null);
    const [showProductsView, setShowProductsView] = useState(false);
    const [listProducts, setListProducts] = useState([]);
    const [pagingProducts, setPagingProducts] = useState(null);
    const [hasMoreProducts, setHasMoreProducts] = useState(true);
    const [showLoadMoreProducts, onShowLoadMoreProducts] = useState(false);
    const [confirm, setConfirm] = useState({});
    const [subActions, setSubActions] = useState(null);
    const [showModalPause, setShowModalPause] = useState({});
    const [pausedPeriod, setPausePeriod] = useState({
        from_date: '',
        to_date: '',
        from_date_epcho: '',
        to_date_epcho: ''
    });
    const [cards, setCards] = useState([]);

    useEffect(() => {
        onInit();
    }, []);

    const onInit = async () => {
        onShowLoading(true);
        // await onGetSubscriptionActions();
        let data = await onLoadSubcriptions();
        // console.log('data:',data);
        // if (data && data.length > 0) {
        //     let periodData = dataUtil.groupBillingPeriodv2(data);
        //     console.log('periodData:',periodData);
        //     if (periodData && periodData.length > 0) {
        //         setPeriodSelected(periodData[0]);
        //     }
        // }
        let from = props.location && props.location.state && props.location.state && props.location.state.from ? props.location.state.from : null;
        console.log("AAAA from====", from);
        if (from === 'paygate') {
            let serviceChangeInfo = getServiceChangeInfo() ? getServiceChangeInfo() : null;
            if (serviceChangeInfo) {
                await onUpdateService(serviceChangeInfo.action, serviceChangeInfo.service_id, serviceChangeInfo.product_id, serviceChangeInfo.price_id);
            }
        }
        if(document._portalConfig.isCustomActivateService){
            await onLoadPaymentMethod();
        }
        onShowLoading(false);
    }

    const onLoadWallet = async () => {
        let accountFinance = null;
        try {
            let result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                accountFinance = result.data;
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
        return accountFinance;
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubcriptions = async (isRefresh) => {
        // onShowLoading(isRefresh ? false : true);
        var subscriptionServices = [];
        var listDevices = [];
        try {
            const result = await crmservices.contacts.getListContactServices();
            console.log("result:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if (subscriptionService.service) {
                        let devices = await onLoadDevices(subscriptionService.service.id);
                        listDevices = listDevices.concat(devices);
                        // subscriptionService.devices = devices;
                    }
                    if (product) {
                        let info = await crmservices.orders.getProductDetail(product.id);
                        console.log("product info:", info);
                        if (info.code == 'OK') {
                            console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                        }
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            console.log("subscriptionServices:", subscriptionServices);
            setSubcriptions(subscriptionServices);
            setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
            let periodData = dataUtil.groupBillingPeriodv2(subscriptionServices);
            console.log('periodData:', periodData);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
                setPeriod(periodData);
            }
            setServiceDevices(listDevices);
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        // onShowLoading(false);
        return subscriptionServices;
    }

    const onCloseFilter = () => {
        setOpenFilter(false);
    }

    const onOpenFilter = () => {
        setOpenFilter(true);
    }

    const handleLoadMore = () => {

    }

    const onUpgrade = async () => {
        onMainLoading(true);
        try {
            const result = await crmservices.contacts.onServiceDelivery('UPGRADE');
            console.log("result onServiceDelivery===", result);
            if (result.code == 'OK') {

            } else {
                setError({
                    showAlert: true,
                    title: 'ERROR',
                    message: t('EXCEPTION_PROCESS'),
                    status: t('ERROR'),
                });
            }
        } catch (ex) {
            console.log("on onServiceDelivery ex:", ex);
        }
        onMainLoading(false);
    }

    const onUpdateService = async (action, service_id, prodId, priceId, pausedPeriod) => {
        onShowLoading(true);
        setConfirm({});
        setShowProductsView(false);
        try {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            let body = {};
            if (action === 'PAUSE') {
                if (pausedPeriod && pausedPeriod.from_date_epcho && pausedPeriod.to_date_epcho) {
                    let from_date = formatPeriodDate(new Date(pausedPeriod.from_date_epcho));
                    let to_date = formatPeriodDate(new Date(pausedPeriod.to_date_epcho));
                    const diffDays = Math.floor((to_date - from_date) / 86400);

                    let scheduled_date = convertEpochTime(pausedPeriod.from_date_epcho);
                    body = {
                        action: action,
                        number_of_days: diffDays,
                        use_proposed_date: false,
                        scheduled_date: scheduled_date,
                    }
                } else {
                    showAlert(true, t('please_select_date'));
                    return false;
                }
            }
            else {
                body = {
                    action: (action === 'UPGRADE' || action === 'DOWNGRADE') ? 'CHANGE' : action,
                    change_to_service: {
                        product_id: prodId,
                        price_terms_id: priceId,
                    },
                    use_proposed_date: false,
                };
            }
            const result = await crmservices.contacts.onUpdateServiceWithBody(service_id, body);
            setServiceChangeInfo(null);
            console.log("result onUpdateService===", result);
            if (result.code == 'OK') {
                let proposed_scheduled_date = null;
                if (result.data && result.data.proposed_scheduled_date) {
                    proposed_scheduled_date = formatDateToDDMMYYYYFrEpoch(result.data.proposed_scheduled_date, true);
                }
                if (proposed_scheduled_date) {
                    let mess = null;
                    if (action === 'UPGRADE') mess = t('confirm_upgrade_service_success_with_date');
                    else if (action === 'DOWNGRADE') mess = t('confirm_down_service_success_with_date');
                    else if (action === 'CANCEL') mess = t('confirm_cancel_service_success_with_date');
                    else if (action === 'PAUSE') mess = t('confirm_pause_service_success_with_date');
                    else if (action === 'RESUME') mess = t('confirm_resume_service_success_with_date');
                    else if (action === 'ACTIVATE') mess = t('confirm_active_service_success_with_date');

                    setConfirm({
                        show: true,
                        message: mess + proposed_scheduled_date + (action === 'UPGRADE' ? "." : "?"),
                        actionTitle: t('yes'),
                        cancelTitle: t('no'),
                        onAction: () => onUpdateChangeServiceWithProposeDate(action, service_id, prodId, priceId, proposed_scheduled_date)
                    });
                } else {
                    let mess = null;
                    if (action === 'UPGRADE') mess = t('upgrade_service_success');
                    else if (action === 'DOWNGRADE') mess = t('down_service_success');
                    else if (action === 'CANCEL') mess = t('cancel_service_success');
                    else if (action === 'PAUSE') mess = t('pause_service_success');
                    else if (action === 'RESUME') mess = t('resume_service_success');
                    else if (action === 'ACTIVATE') mess = t('active_service_success');

                    showAlert(true, mess);
                    if (!proposed_scheduled_date) await onInit();
                }
            } else {
                let mess = null;
                if (result.data && result.data.message) {
                    mess = result.data.message;
                }
                else if (action === 'UPGRADE') mess = t('upgrade_service_failed');
                else if (action === 'DOWNGRADE') mess = t('down_service_failed');
                else if (action === 'CANCEL') mess = t('cancel_service_failed');
                else if (action === 'PAUSE') mess = t('pause_service_failed');
                else if (action === 'RESUME') mess = t('resume_service_failed');
                else if (action === 'ACTIVATE') mess = t('active_service_failed');
                else mess = t('EXCEPTION_PROCESS');

                showAlert(true, mess);
            }
        } catch (ex) {
            console.log("onUpdateService ex:", ex);
        }
        onShowLoading(false);
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        onMainLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    const onRecurringPayment = () => { }

    const onLoadDevices = async (service_id) => {
        let devices = [];
        try {
            var result = await crmservices.contacts.getListServiceDevices({
                service_id: service_id,
            });
            console.log("result getDevices==", result);
            if (result.code === 'OK') {
                devices = result.data && result.data.content ? result.data.content : [];
            }
        }
        catch (ex) {
            console.log("onLoadDevices exception===", ex);
        }
        return devices;
    }

    const onChangeService = async (item) => {
        try {
            let service = item && item.service ? item.service : null;
            let subscription = item && item.subscription ? item.subscription : null;
            if (service) {
                setSubscriptionSelected(subscription);
                setServiceSelected(service);
                let prodId = service.product && service.product.id ? service.product.id : null;
                let products = await onLoadProductsTier(prodId);
                if (products && products.length > 0){
                    setShowProductsView(true);
                }
                else {
                    showAlert(true, t('no_available_change_service'));
                }
            }
        }
        catch (ex) {
            console.log("onChangeService exception==", ex);
        }
    }

    const onLoadProductsTier = async (prodId) => {
        let products = [];
        onMainLoading(true);
        try {
            let params = {};
            params.prodId = prodId;

            const result = await crmservices.products.getProductsTier({ ...params });
            console.log("result getProductsTier1===", result);
            if (result.code == 'OK') {
                products = result.data && result.data.content ? result.data.content : [];
                setListProducts(products);
                setPagingProducts(result.data.paging);
                if (result.data.content.length === 0)
                    setHasMoreProducts(false);
            } else {
                setError({
                    showAlert: true,
                    title: 'ERROR',
                    message: t('EXCEPTION_PROCESS'),
                    status: t('ERROR'),
                });
            }
        } catch (ex) {
            console.log("on getProductsTier ex:", ex);
        }
        onMainLoading(false);
        return products;
    }

    const handleLoadMoreProductsTier = async () => {
        let params = { ...pagingProducts };
        params.page = params.page + 1;
        params.prodId = serviceSelected && serviceSelected.product && serviceSelected.product.id ? serviceSelected.product.id : null;

        try {
            onShowLoadMoreProducts(true);
            try {
                let result = await crmservices.products.getProductsTier({ ...params });
                console.log('getProductsTier load more== ', result)
                if (result.code === 'OK') {
                    let new_products = result.data && result.data.content ? result.data.content : [];
                    setListProducts([...listProducts, ...new_products]);
                    setPagingProducts(result.data.paging);

                    if (result.data.content.length === 0)
                        setHasMoreProducts(false);
                }
            } catch (error) {
                console.log("getProductsTier exception:", error);
            }
            onShowLoadMore(false);
        } catch (error) {
            console.log("getProductsTier Load More Exception:", error);
        }
    }

    const onConfirmChangeService = (product, priceSelected) => {
        console.log("AAAAA product: ", product)
        console.log("AAAAA priceSelected: ", priceSelected)
        if(priceSelected){
            setConfirm({
                show: true,
                message: t('confirm_change_service') + product.name + "?",
                actionTitle: t('yes'),
                cancelTitle: t('no'),
                onAction: () => onServiceDelivery(product, priceSelected)
            });
        } else {
            showAlert(true, t('please_choose_price'));
            return false;
        }
    }

    const onServiceDelivery = async (product, priceSelected) => {
        console.log("product===", product);
        onShowLoading(true);
        setConfirm({});
        try {
            let action = product && product.change_type ? product.change_type : null;
            let service_id = serviceSelected && serviceSelected.id ? serviceSelected.id : null;
            let product_id = product.id;
            let subscription_id = subscriptionSeleted && subscriptionSeleted.id ? subscriptionSeleted.id : null;
            let price_id = priceSelected ? priceSelected.id : null;

            const result = await crmservices.contacts.onServiceDelivery({
                action: "CHANGE",
                services_to_change: [{
                    from_service_id: service_id,
                    to_service_product_id: product_id,
                    to_price_terms_id: price_id,
                }],
                subscription_id: subscription_id,
            });
            console.log("result onServiceDelivery===", result);
            // debugger;
            if (result.code === 'OK') {
                //bg ayna ott
                if (domainName === 'ayna' && document._portalConfig.usePaymentLocal) {
                    let sumTotalAmount = 0;
                    if (result.data && result.data.service_delivery_estimate && result.data.service_delivery_estimate.length > 0) {
                        result.data.service_delivery_estimate.forEach(item => {
                            if (item.billing_estimate && item.billing_estimate.totals && item.billing_estimate.totals.total_amount) {
                                sumTotalAmount += item.billing_estimate.totals.total_amount;
                            }
                        });
                    }
                    sumTotalAmount = Number(sumTotalAmount.toFixed(2));
                    //change service normal
                    if (sumTotalAmount <= 0) {
                        await onUpdateService(action, service_id, product_id, price_id);
                    }
                    //check with balance of account
                    else{
                        let accountFinance = await onLoadWallet();
                        //balance account
                        if (accountFinance.balance < 0) {
                            if (sumTotalAmount <= Math.abs(accountFinance.balance)) {
                                await onUpdateService(action, service_id, product_id, price_id);
                            }
                            //create topup with SSL commerz
                            else {
                                setServiceChangeInfo({
                                    action: action,
                                    service_id: service_id,
                                    product_id: product_id,
                                    price_id: price_id,
                                });
                                let amounts = Number((sumTotalAmount - Math.abs(accountFinance.balance)).toFixed(2));
                                await onTopup(accountFinance, { amount: amounts });
                            }
                        }
                        else {
                            //create topup with SSL commerz
                            setServiceChangeInfo({
                                action: action,
                                service_id: service_id,
                                product_id: product_id,
                                price_id: price_id,
                            });
                            let amounts = Number((sumTotalAmount + accountFinance.balance).toFixed(2));
                            await onTopup(accountFinance, { amount: amounts });
                        }
                    }
                }
                //flow normal portal
                else {
                    await onUpdateService(action, service_id, product_id, price_id);
                }
            }
            else if (result.data && result.data.error && result.data.error == "FINANCE.EXCEPTIONS.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION") {
                showAlert(true, t('change_service_failed_credit_limit'));
            }
            else {
                let mess = result.data && result.data.message ? result.data.message : t('EXCEPTION_PROCESS');
                showAlert(true, mess);
            }
        } catch (ex) {
            console.log("on onServiceDelivery ex:", ex);
        }
        onShowLoading(false);
    }

    const onUpdateChangeServiceWithProposeDate = async (action, service_id, prodId, priceId, proposed_scheduled_date) => {
        onShowLoading(true);
        setConfirm({});
        try {
            let body = {
                action: (action === 'UPGRADE' || action === 'DOWNGRADE') ? 'CHANGE' : action,
                change_to_service: {
                    product_id: prodId,
                    price_terms_id: priceId,
                },
                use_proposed_date: true,
            };
            const result = await crmservices.contacts.onUpdateServiceWithBody(service_id, body);
            console.log("result onUpdateService===", result);
            if (result.code == 'OK') {
                setShowProductsView(false);
                if (proposed_scheduled_date) {
                    let mess = null;
                    if (action === 'UPGRADE') mess = t('upgrade_service_success_with_date');
                    else if (action === 'DOWNGRADE') mess = t('down_service_success_with_date');
                    else if (action === 'CANCEL') mess = t('cancel_service_success_with_date');
                    else if (action === 'PAUSE') mess = t('pause_service_success_with_date');
                    else if (action === 'RESUME') mess = t('resume_service_success_with_date');
                    else if (action === 'ACTIVATE') mess = t('active_service_success_with_date');

                    showAlert(true, mess + proposed_scheduled_date + ".");
                } else {
                    let mess = null;
                    if (action === 'UPGRADE') mess = t('upgrade_service_success');
                    else if (action === 'DOWNGRADE') mess = t('down_service_success');
                    else if (action === 'CANCEL') mess = t('cancel_service_success');
                    else if (action === 'PAUSE') mess = t('pause_service_success');
                    else if (action === 'RESUME') mess = t('resume_service_success');
                    else if (action === 'ACTIVATE') mess = t('active_service_success');

                    showAlert(true, mess);
                }
                await onInit();
            } else {
                let mess = null;
                if (result.data && result.data.message) {
                    mess = result.data.message;
                }
                else if (action === 'UPGRADE') mess = t('upgrade_service_failed');
                else if (action === 'DOWNGRADE') mess = t('down_service_failed');
                else if (action === 'CANCEL') mess = t('cancel_service_failed');
                else if (action === 'PAUSE') mess = t('pause_service_failed');
                else if (action === 'RESUME') mess = t('resume_service_failed');
                else if (action === 'ACTIVATE') mess = t('active_service_failed');
                else mess = t('EXCEPTION_PROCESS');

                showAlert(true, mess);
            }
        } catch (ex) {
            console.log("update service exception===", ex);
        }
        onShowLoading(false);
    }

    const showAlert = async (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }

    const onGetSubscriptionActions = async () => {
        try {
            let result = await crmservices.contacts.getSubscriptonActions();
            console.log("result onGetSubscriptionActions===", result);
            if (result.code === 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) {
                    setSubActions(result.data.content);
                }
            }
        } catch (ex) {
            console.log("onGetSubscriptionActions exception: ==", ex);
        }
    }

    const onConfirmActionsService = (action, item) => {
        if (item && item.service) {
            setServiceSelected(item.service);
            let service = item && item.service ? item.service : null;
            let service_id = service && service.id ? service.id : null;
            let product = service && service.product ? service.product : null;
            let product_id = product && product.id ? product.id : null;
            let price = product && product.prices && product.prices.length > 0 ? product.prices[0] : null;
            let priceId = price && price.id ? price.id : null
            let mess = null;
            if (action === 'CANCEL') mess = t('confirm_cancel_service');
            // else if(action === 'PAUSE') mess  = t('confirm_pause_service');
            else if (action === 'RESUME') mess = t('confirm_resume_service');
            else if (action === 'ACTIVATE') mess = t('confirm_active_service');
            if (action === 'PAUSE') {
                setShowModalPause({
                    show: true,
                    message: t('pause_service'),
                    actionTitle: t('btn_continue'),
                    cancelTitle: t('cancel'),
                });
            } else {
                setConfirm({
                    show: true,
                    message: mess,
                    actionTitle: t('yes'),
                    cancelTitle: t('no'),
                    onAction: () => onUpdateService(action, service_id, product_id)
                });
            }
        }
    }

    const onPauseService = async () => {
        console.log("serviceSelected===", serviceSelected);
        if (pausedPeriod && pausedPeriod.from_date_epcho && pausedPeriod.to_date_epcho) {
            setShowModalPause({});
            setPausePeriod({
                from_date: '',
                to_date: '',
                from_date_epcho: '',
                to_date_epcho: '',
            });
            await onUpdateService("PAUSE", serviceSelected && serviceSelected.id ? serviceSelected.id : null, null, null, pausedPeriod);
        } else {
            showAlert(true, t('please_select_date'));
        }
    }

    const onChangeDate = async (field, value) => {
        let fromDate = null;
        let toDate = null;
        if (field === 'from_date') {
            fromDate = value;
            setPausePeriod({
                ...pausedPeriod,
                [field]: formatDateToDDMMYYYY(value),
                from_date_epcho: fromDate,
            });
        } else {
            toDate = value;
            setPausePeriod({
                ...pausedPeriod,
                [field]: formatDateToDDMMYYYY(value),
                to_date_epcho: toDate,
            });
        }
        console.log("onChangeDate Date ===", field);
        setShowModalPause({
            ...showModalPause,
            show: true,
            pausedPeriod: pausedPeriod,
        });
    }

    const onTopup = async (accountFinance, values) => {
        onShowLoading(true);
        console.log("values onToup===", values);
        if (values && values.amount && Number(values.amount) > 0) {
            let hasPhone = true;
            let hasAddress = true;
            if (domainName === 'ayna' && document._portalConfig.usePaymentLocal) {
                hasPhone = await onLoadPhone();
                hasAddress = await onLoadAddresses();
            }
            if (hasPhone && hasAddress) {
                try {
                    let urlPortal = window.location.origin;
                    let body = {
                        account_id: accountFinance && accountFinance.id ? accountFinance.id : null,
                        total_amount: values.amount,
                        currency: accountFinance && accountFinance.currency_code ? accountFinance.currency_code : null,
                        payment_result_url: urlPortal + paths.paygate_payment_result,
                        payment_redirect_url: document._portalConfig.urlPlugins + "/plugins",
                    };
                    let result = await aynaottservices.initiateTopup(body);
                    console.log("result onTopup ===", result);
                    if (result.code === 'OK') {
                        if (result.data && result.data.status === 'SUCCESS') {
                            if (result.data.redirect_url) window.location.href = result.data.redirect_url;
                        } else {
                            let mess = result.data.failed_reason ? result.data.failed_reason : t('EXCEPTION_PROCESS');
                            showAlert(true, mess);
                        }
                    } else if (result.error && result.error.error === 'CONTACT_ADDRESS_NOT_FOUND') {
                        setServiceChangeInfo(null);
                        showAlert(true, t('CONTACT_ADDRESS_NOT_FOUND'));
                    } else if (result.error && result.error.error === 'CONTACT_PHONE_NOT_FOUND') {
                        setServiceChangeInfo(null);
                        showAlert(true, t('CONTACT_PHONE_NOT_FOUND'));
                    } else {
                        setServiceChangeInfo(null);
                        let mess = result.error && result.error.message ? result.error.message : t('EXCEPTION_PROCESS')
                        showAlert(true, mess);
                    }
                } catch (ex) {
                    console.log("onToup exception ex===", ex);
                }
            } else {
                setServiceChangeInfo(null);
                showAlert(true, t('CONTACT_PHONE_OR_ADDRESS_NOT_FOUND_TOPUP'));
            }
        }
        else {
            setServiceChangeInfo(null);
            showAlert(true, t('amount_greater_than_0'));
        }
        onShowLoading(false);
    }

    const onLoadPhone = async () => {
        let hasPhone = false;
        try {
            var phoneResult = await crmservices.contacts.getPhones();
            console.log('MyProfile onLoadProfile phoneResult=', phoneResult)
            if (phoneResult.code === 'OK') {
                var content = phoneResult.data.content;
                if (content && content.length > 0) {
                    var phone = content.filter(p => p.is_primary);
                    if (phone && phone.length > 0) {
                        hasPhone = true;
                    }
                } else {
                    hasPhone = false;
                }
            }
        } catch (ex) {
            console.log("onLoadPhone exception===", ex);
        }
        return hasPhone;
    }

    const onLoadAddresses = async () => {
        let hasAddress = false;
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log('onLoadAddresses result==', result)
            if (result.code === 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) {
                    hasAddress = true;
                }
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        return hasAddress;
    }

    const onLoadPaymentMethod = async () => {
        try
        {
            let result = await crmservices.contacts.getListPaymentMethods();
            console.log("result onLoadPaymentMethod ===", result);
            if(result.code === 'OK'){
                setCards(result.data.content);
            }
        }catch(ex){
            console.log("onLoadPaymentMethod exception: ", ex);
        }
    }

    console.log("pausedPeriod===", pausedPeriod)

    return (
        <div>
            <SubcriptionsView
                periods={periods}
                subcriptions={dataUtil.groupServicesByMonthv2(subcriptions, periodSelected)}
                periodSelected={periodSelected}
                showLoading={showLoading}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                serviceDevices={serviceDevices}
                showModalPause={showModalPause}
                cards={cards}
                currency={getCurrency()}
                handleLoadMore={handleLoadMore}
                onOpenFilter={onOpenFilter}
                onChangeTab={onChangeTab}
                onUpgrade={onUpgrade}
                onRecurringPayment={onRecurringPayment}
                onChangeService={onChangeService}
                onConfirmActionsService={onConfirmActionsService}
                onPauseService={onPauseService}
                setPausePeriod={setPausePeriod}
                setShowModalPause={setShowModalPause}
                onChangeDate={onChangeDate}
            />

            {showProductsView && <ProductsView
                open={showProductsView}
                listProducts={listProducts}
                showLoading={showLoading}
                hasMore={hasMoreProducts}
                showLoadMore={showLoadMoreProducts}
                currency={getCurrency()}
                onClickDetail={onConfirmChangeService}
                handleLoadMore={handleLoadMoreProductsTier}
                onClose={() => setShowProductsView(false)}
            />}
            {mainLoading && <Loading showLoading={mainLoading} />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />

            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message ? confirm.message : null}
                confirm={confirm.actionTitle ? confirm.actionTitle : null}
                buttonLabel={confirm.cancelTitle ? confirm.cancelTitle : null}
                onAction={confirm.onAction ? () => confirm.onAction() : null}
            />}
        </div>
    );
}

export default withStyles(styles)(withTranslation()(Subcriptions));